// Mappa sezione → tipi di notifica "novità" da marcare LETTE all'apertura della sezione.
// NON include le pendenze d'azione (presa visione, verifica pagamento, attività): quelle
// restano con indicatore distinto finché non vengono effettivamente evase.
export const SECTION_NOTIF_TYPES = {
  // Admin
  "/platform/crm/venditori": ["agent_submitted"],
  "/platform/crm/documenti": ["document_signed"],
  "/platform/crm/extra": ["extra_requested", "extra_ack", "extra_quote", "extra_commission_matured", "extra_delivered", "extra_rejected"],
  "/platform/crm/provvigioni": ["cancellation_requested", "commission_matured", "commission_previewed"],
  "/platform/crm/modalita": ["mode_change_requested"],
  "/platform/crm/progetti": ["project_ready", "project_created", "project_state", "ticket_opened", "ticket_reopened", "ticket_update"],
  "/platform/crm/pagamenti": ["receipt_uploaded", "obligation_created", "payment_verified"],
  "/platform/crm/materiali": ["material_acknowledged"],
  "/platform/crm/report": ["agent_invoice_registered", "month_closed"],
  "/platform/crm/contatti": ["contact_assigned", "deal_won"],
  // Agente
  "/agent/materials": ["material_assigned", "material_acknowledged"],
  "/agent/documenti": ["document_to_sign", "document_signed", "document_verified", "document_correction_requested"],
  "/agent/prospetti": ["prospetto_approved", "commission_liquidated", "month_closed"],
  "/agent/commissions": ["commission_matured", "commission_liquidated", "commission_previewed"],
  "/agent/modalita": ["mode_change_approved", "mode_change_rejected"],
  "/agent/extra": ["extra_quote", "extra_ack", "extra_commission_matured", "extra_delivered"],
  "/agent/progetti": ["project_ready", "project_state", "ticket_update", "ticket_reopened"],
  "/agent/contacts": ["contact_assigned"],
  "/agent/deals": ["deal_won"],
};

export function typesForPath(pathname) {
  for (const key of Object.keys(SECTION_NOTIF_TYPES)) {
    if (pathname.startsWith(key)) return SECTION_NOTIF_TYPES[key];
  }
  return null;
}
